import styled from 'styled-components';
import {
  aspect,
  svg,
  mq,
  buttonReset,
  focusOutline,
  safeFocusRemoval,
  heading_xl,
  heading_s
} from '_utils/styles';
import { Image as SCImage } from '@sitecore-jss/sitecore-jss-react';
import { spacing } from '_utils/props';

export const PreviewContainer = styled.figure`
  margin: 0;

  ${aspect(16, 9)}

  &.triple {
    ${aspect(17, 16)}
  }

  ${mq('lg')} {
    ${aspect(21, 9)}

    &.triple {
      ${aspect(21, 9)}
    }
  }

  background-color: ${({ theme }) => theme.colors.background.secondary};
  position: relative;
  & + & {
    ${({ theme }) => spacing({ theme, $mt: 2 })}
  }
`;

export const EditorTitle = styled.p`
  ${heading_s}
  margin-top: 32px;
`;

export const ImageContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  &.double {
    width: calc(50% - 1px);

    &:nth-of-type(2) {
      left: auto;
      right: 0;
    }
  }

  &.triple {
    &:nth-of-type(1) {
      height: calc(60% - 1px);
    }
    &:nth-of-type(2) {
      width: calc(50% - 1px);
      height: calc(40% - 1px);
      top: auto;
      bottom: 0;
    }
    &:nth-of-type(3) {
      width: calc(50% - 1px);
      height: calc(40% - 1px);
      left: auto;
      right: 0;
      top: auto;
      bottom: 0;
    }

    ${mq('lg')} {
      &:nth-of-type(1) {
        width: calc(68% - 1px);
        height: 100%;
      }
      &:nth-of-type(2) {
        width: calc(32% - 1px);
        height: calc(50% - 1px);
        left: auto;
        right: 0;
        top: 0;
        bottom: auto;
      }
      &:nth-of-type(3) {
        width: calc(32% - 1px);
        height: calc(50% - 1px);
        left: auto;
        right: 0;
        top: auto;
        bottom: 0;
      }
    }
  }
`;

export const Image = styled(SCImage)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
  object-position: 50% 50%;
  font-family: 'object-fit: cover; object-position: 50% 50%;';
`;

export const ExpandButton = styled.button`
  ${buttonReset()}

  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  &:focus {
    ${safeFocusRemoval}
    ${focusOutline}
  }

  &:focus {
    outline-offset: -2px;
  }
`;

export const ExpandableIndicator = styled.div<{ariaHidden?: boolean}>`
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: rgba(4, 28, 44, 0.5);
  right: 8px;
  top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExpandableWrapper = styled.span`
  ${svg(16, 16)}
  width: 13px;
  flex: none;
  path {
    fill: white;
  }

  @media (hover: hover) {
    transition: transform 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
    ${ExpandButton}:hover & {
      transform: scale(1.3);
    }
  }
`;

export const ShowMore = styled.div`
  background-image: linear-gradient(0deg, rgba(4, 28, 44, 0.5), rgba(4, 28, 44, 0.5));
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ShowMoreCount = styled.span`
  ${() => heading_xl()}
  color: ${({ theme }) => theme.colors.element.white};  
`;

export const ImageListContainer = styled.div`
  position: relative;
  height: 70vh;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  overflow-x: scroll;
`;
export const ImageListBlock = styled.div`
  min-width: 100%;
  width: 100%;
  margin-right: 20px;
`;

export const ImageListGridY = styled.div`
  display: flex;
  height: 100%;
  flex-flow: column nowrap;
`;

export const ImageCell = styled.div`
  height: 66.66667%;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  min-height: 0;
  min-width: 0;
`;

export const CaptionCell = styled.div`
  overflow-y: auto;
  padding: 1em;

  height: 33.33333%;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  min-height: 0;
  min-width: 0;
  p {
    margin: 0;
    padding: 0;
  }
`;
export const CaptionWrap = styled.div`
  width: 60%;
  margin: 0 auto;
`;

export const ExpEdImage = styled(SCImage)`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
